export class GameStateEvents {
  static ON_ENTER_PRE_EVENT_GAME_STATE = "onEnterPreEventGameState";
  static ON_ENTER_WARM_UP_STATE = "onEnterWarmUpState";
  static ON_ENTER_PRE_RACE_STATE = "onEnterPreRaceState";
  static ON_ENTER_RACE_IN_PROGRESS_STATE = "onEnterRaceInProgressState";
  static ON_ENTER_POST_RACE_STATE = "onEnterPostRaceState";
  static ON_ENTER_POST_EVENT_STATE = "onEnterPostEventState";
  static ON_ENTER_END_EVENT_STATE = "onEnterEndEventState";
}

export class EulerStateEvents {
  static ON_ENTER_GET_CURRENT_EVENT_STATE = "onEnterGetCurrentEventState";
  static ON_ENTER_GET_NEXT_EVENT_STATE = "onEnterGetNextEventState";
  static ON_ENTER_LOAD_AND_SHOW_ODDS_STATE = "onEnterLoadAndShowsOddsState";
  static ON_ENTER_NO_MORE_BETS_STATE = "onEnterNoMoreBetsState";
  static ON_UPDATE_PLAYING_STATE = "onEnterUpdatePlayingState";
  static ON_EVENT_PLAYING_STATE = "onEnterEventPlayingState";
  static ON_EVENT_END_STATE = "onEnterEventEndStateListeners";
}

export class EulerMessageStatuses {
  static PENDING = "pending";
  static READY = "ready";
  static END_BETS = "endbets";
  static START = "start";
  static RUNNING = "running";
  static COMPLETED = "completed";
  static CLOSED = "closed";
  static VOIDED = "Voided";

  static NOMOREBETS = "NoMoreBets";
}

export class EventDataEvents {
  static ON_DATA_ASSIGNED = "onDataAssigned";
  static ON_ARRIVAL_ORDER_ASSIGNED = "onArrivalOrderAssigned";
  static ON_COMPLETED_MESSAGE_RECEIVED = "onCompletedMessageReceived";
}

export class RaceOrderEvents {
  static ON_RACE_ORDER_UPDATED = "onRaceOrderUpdatedJS";
}

export class AnimatorManagerEvents {
  static ON_ANIMATION_DOWNLOADED = "onAnimationDownloaded";
}

export class CommentaryEvents {
  static ON_COMMENTARY_UPDATED = "onCommentaryUpdated";
}

export class GameStates {
  static PRE_EVENT_STATE = "PreEventState";
  static WARM_UP_STATE = "WarmUpState";
  static PRE_RACE_STATE = "PreRaceState";
  static RACE_IN_PROGRESS_STATE = "RaceInProgressState";
  static POST_RACE_STATE = "PostRaceState";
  static POST_EVENT_STATE = "PostEventState";
  static END_EVENT_STATE = "EndEventState";
}

export class EulerStates {
  static GET_CURRENT_EVENT_STATE = "GetCurrentEvent";
  static GET_NEXT_EVENT_STATE = "GetNextEvent";
  static LOAD_AND_SHOW_ODDS_STATE = "LoadAndShowOdds";
  static NO_MORE_BETS_STATE = "NoMoreBets";
  static UPDATE_PLAYING_STATE = "UpdatePlaying";
  static EVENT_PLAYING_STATE = "EventPlaying";
  static EVENT_END_STATE = "EventEnd";
}

export class AnimatorStateTransitions {
  static START_RACE = "START_RACE";
  static IDLE = "IDLE";
  static RUN = "RUN";
  static WHIP = "WHIP";

  static IDLE_OFFSET = "IdleOffset";
  static START_OFFSET = "StartOffset";
  static START_OFFSET_SPEED_MULTIPLIER = "StartOffsetSpeedMultiplier";
  static RUN_OFFSET = "RunOffset";
  static SPEED_MULTIPLIER = "SpeedMultiplier";
}

export class Tags {
  static FINISH = "Finish";
  static ANIMATION_CHANGE_POINT = "AnimationChangePoint";
  static RACER = "Racer";
}

export class Timings {
  static WARM_UP_GRACE_PERIOD = 8; //seconds. If the warm up state is active for more than this time, reload the page (hacky way of avoiding rare start time issue)
  static RACE_START_GRACE_PERIOD = 30; //seconds
}
